module.exports = __webpack_public_path__ + "static/media/YB5F08_2.2ac4e294.jpg";